export enum StatusAlarm {
    Fatal = 'fatal',
    Info = 'info',
    Warn = 'warn',
    Error = 'error'
}

export const statusAlarmReturnColor = (status: string | undefined): string => {
    status == undefined ? (status = '') : (status = status.toLowerCase())
    switch (status) {
        case StatusAlarm.Fatal:
            return '#AE1F1F'
        case StatusAlarm.Error:
            return '#FF4000'
        case StatusAlarm.Info:
            return '#00BFFF'
        case StatusAlarm.Warn:
            return '#FF9326'
        default:
            return '#000'
    }
}
